const VerticalDivider = ({ colorClass }) => (
  <div className={`${colorClass} w-px`}></div>
);
export default VerticalDivider;
